import { Flex } from "@chakra-ui/react";
import RepeatDropdown from "../../../compoenets/organism/TaskDetail/RepeatDropdown";
import { RepeatDropdownOptionsType } from "../../../types/block/enum";
import { calculateInterval } from "../../../utils/common/dateTime/timeInterval";
import { rRuleToText } from "../../../utils/taskDetail/recurrenceConverter";
import AlldayToggle from "./AlldayToggle";
import styles from "./DateModal.module.css";
import { CloseIcon } from "../../../icons";
import { useDateModalContext } from "./DateModalContext";

const DateTimeControl: React.FC = () => {
  const {
    dateTimeStart,
    dateTimeEnd,
    isAllDay,
    handleIsAllDay,
    handleRepeatChange,
    handleOnDelete,
    recurrence,
    isTask,
    repeatModalRef,
    isNewBlock,
  } = useDateModalContext();

  return (
    <div className={styles.time_sub_btns}>
      {!isAllDay && (
        <span className={styles["date-interval"]}>
          {calculateInterval(dateTimeStart!, dateTimeEnd!)}
        </span>
      )}

      <AlldayToggle
        isAllDay={isAllDay}
        handleIsAllDay={handleIsAllDay}
      />

      <RepeatDropdown
        repeatDropdownRef={repeatModalRef}
        selectedRepeat={rRuleToText(recurrence ?? []) as RepeatDropdownOptionsType}
        onValueChange={handleRepeatChange}
      />

      {!isNewBlock && isTask && (
        <div
          className={`${styles.selectedGuestRowDelete} text-[#787D80] hover:fill-white hover:text-white`}
          onClick={handleOnDelete}
        >
          <div className={styles.iconDescription}>Delete</div>
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            fontSize={"16px"}
          >
            <CloseIcon />
          </Flex>
        </div>
      )}
    </div>
  );
};

export default DateTimeControl;
